import Vue from "vue";
import App from "./App.vue";
import VueAnalytics from "vue-analytics";
import VueMeta from "vue-meta";
import VueApexCharts from 'vue-apexcharts'
import * as VueGoogleMaps from 'vue2-google-maps'

import axios from "axios";
import router from "./router";
import store from "./store";
import vuetify from './plugins/vuetify';
import Vuetify from 'vuetify/lib'
import VueSweetalert2 from 'vue-sweetalert2';

import {
 ProgressPlugin
} from "bootstrap-vue";

let appName = 'Local Recon'

Vue.use(VueMeta);

Vue.use(Vuetify)

Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBqF2vFVUoyeU3la0XVOQSOdkhgAfQdBEs',
    libraries: 'places',
  }
});

Vue.use(ProgressPlugin)

Vue.use({
  install() {
      Vue.appName = appName;
      Vue.prototype.$appName = appName;
  }
});

new Vue({
  router
});

require("./assets/styles/main.css");

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount("#app");